// Whether Retry is offered for a doc (TT-1273): the doc read's
// `doc.failure.retryable`, the same rule the retry PUT applies on the
// platform. Nothing here reads a doc's type, status, title or content.
export function canRetry(failure) {
  return failure?.retryable === true;
}
